import styled from 'styled-components';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export const ImageCustom = styled(LazyLoadImage)`
  object-fit: cover;
  height: 84px;
  width: 84px;
`;
